import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetCurrentUserCustomerIdsQueryVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
}>;


export type GetCurrentUserCustomerIdsQuery = { __typename?: 'query_root', usertocustomers: Array<{ __typename?: 'usertocustomers', customer_id: number, customer: { __typename?: 'customers', id: number, name?: string | null, tier: string, effective_config?: object | null, contracts: Array<{ __typename?: 'contracts', id: number, artriggers: Array<{ __typename?: 'artriggers', id: number, product_key: string }> }> } }> };


export const GetCurrentUserCustomerIdsDocument = gql`
    query GetCurrentUserCustomerIds($userId: bigint!) {
  usertocustomers(where: {user_id: {_eq: $userId}}) {
    customer_id
    customer {
      id
      name
      tier
      effective_config
      contracts(
        where: {begin_date: {_lte: "now()"}, _or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}]}
      ) {
        id
        artriggers {
          id
          product_key
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserCustomerIdsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserCustomerIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserCustomerIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserCustomerIdsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCurrentUserCustomerIdsQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserCustomerIdsQuery, GetCurrentUserCustomerIdsQueryVariables> & ({ variables: GetCurrentUserCustomerIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserCustomerIdsQuery, GetCurrentUserCustomerIdsQueryVariables>(GetCurrentUserCustomerIdsDocument, options);
      }
export function useGetCurrentUserCustomerIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserCustomerIdsQuery, GetCurrentUserCustomerIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserCustomerIdsQuery, GetCurrentUserCustomerIdsQueryVariables>(GetCurrentUserCustomerIdsDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserCustomerIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserCustomerIdsQuery, GetCurrentUserCustomerIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserCustomerIdsQuery, GetCurrentUserCustomerIdsQueryVariables>;
export function useGetCurrentUserCustomerIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserCustomerIdsQuery, GetCurrentUserCustomerIdsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserCustomerIdsQuery | undefined, GetCurrentUserCustomerIdsQueryVariables>;
export function useGetCurrentUserCustomerIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserCustomerIdsQuery, GetCurrentUserCustomerIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserCustomerIdsQuery, GetCurrentUserCustomerIdsQueryVariables>(GetCurrentUserCustomerIdsDocument, options);
        }
export type GetCurrentUserCustomerIdsQueryHookResult = ReturnType<typeof useGetCurrentUserCustomerIdsQuery>;
export type GetCurrentUserCustomerIdsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserCustomerIdsLazyQuery>;
export type GetCurrentUserCustomerIdsSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserCustomerIdsSuspenseQuery>;
export type GetCurrentUserCustomerIdsQueryResult = Apollo.QueryResult<GetCurrentUserCustomerIdsQuery, GetCurrentUserCustomerIdsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/getCurrentUserCustomerIds.query.gql}
 */
export async function getCurrentUserCustomerIds(
  variables: GetCurrentUserCustomerIdsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetCurrentUserCustomerIdsQuery['usertocustomers']>
export async function getCurrentUserCustomerIds(
  variables: GetCurrentUserCustomerIdsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetCurrentUserCustomerIdsQuery>
export async function getCurrentUserCustomerIds(
  variables: GetCurrentUserCustomerIdsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetCurrentUserCustomerIdsQuery['usertocustomers'] | GetCurrentUserCustomerIdsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetCurrentUserCustomerIdsQuery>(
    GetCurrentUserCustomerIdsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.usertocustomers
}